import { useTranslation } from "react-i18next";
import { Button } from "~/components/button";
import { Switch } from "~/components/ui/switch";

interface KeywordsTabActionsProps {
  showReasoning: boolean;
  onShowReasoningChange: (value: boolean) => void;
  onPipelineInfoOpen?: () => void;
  isRegenerating?: boolean;
  onRefresh?: () => void;
}

export const KeywordsTabActions = ({
  showReasoning,
  onShowReasoningChange,
  onPipelineInfoOpen,
  isRegenerating = false,
  onRefresh,
}: KeywordsTabActionsProps) => {
  const { t } = useTranslation(["components", "general"]);

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        <Switch
          id="keyword-reasoning-toggle"
          checked={showReasoning}
          onCheckedChange={onShowReasoningChange}
          data-testid="keyword-reasoning-toggle"
        />
        <label
          htmlFor="keyword-reasoning-toggle"
          className="text-sm font-medium text-secondary-700 cursor-pointer"
        >
          {t("components:keywordsTab.keywordsTabActions.keywordReasoning")}
        </label>
      </div>
      {onPipelineInfoOpen && (
        <Button
          icon="circle-question-mark"
          variant="tertiary"
          size="small"
          onClick={onPipelineInfoOpen}
          analyticsId="button_pipeline_info"
          testId="keywords-pipeline-info-button"
          className="size-8 flex items-center justify-center"
        />
      )}
      {onRefresh && (
        <Button
          onClick={onRefresh}
          label={t("general:buttons.refresh")}
          icon={isRegenerating ? "loader" : "sparkles"}
          iconClassName={isRegenerating ? "animate-spin" : undefined}
          disabled={isRegenerating}
          variant="tertiary"
          size="small"
          analyticsId="button_refresh_keywords"
          testId="keywords-refresh-button"
        />
      )}
    </div>
  );
};
